export const getInitial = (name?: string) => {
  if (!name) return "";
  if (typeof name !== "string") return "";

  return name.trim().charAt(0) + ".";
};

export const nameWithFirstLastnameInitial = (name?: string, lastname?: string) => {
  if (!name) return "";
  if (typeof name !== "string") return "";

  const sanitizedName = name.trim();

  if (!lastname) return sanitizedName;
  if (typeof name !== "string") return sanitizedName;

  const sanitizedLastname = lastname.trim();

  return sanitizedName + " " + getInitial(sanitizedLastname);
};

export const getInitials = (name: string): string => {
  const sanitizedName = name.trim().split(" ");

  if (sanitizedName[1]) {
    return `${sanitizedName[0][0]}${sanitizedName[1][0]}`.toUpperCase();
  }

  return `${sanitizedName[0][0]}`.toUpperCase();
};
